import { render, staticRenderFns } from "./PPMFiltersReports.vue?vue&type=template&id=7882bb3e&"
import script from "./PPMFiltersReports.vue?vue&type=script&lang=ts&"
export * from "./PPMFiltersReports.vue?vue&type=script&lang=ts&"
import style0 from "./PPMFiltersReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PPMFiltersReports.vue"
export default component.exports